/**
 * Product chooser card: when a pack size is picked, updates the variant the Add to cart form
 * submits, the photo, the price and cost per wipe, the View details link, and whether the button can be used.
 * Without this script the card still works with the size that was selected on page load.
 */
class ChooserCard extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    this.addEventListener('change', this.#onChange, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const { price = '', perWipe = '', url = '', available } = input.dataset;

    const variantInput = this.querySelector('[data-chooser-variant]');
    if (variantInput instanceof HTMLInputElement) variantInput.value = input.value;

    const priceElement = this.querySelector('[data-chooser-price]');
    if (priceElement) priceElement.textContent = price;

    const perWipeElement = this.querySelector('[data-chooser-per-wipe]');
    if (perWipeElement instanceof HTMLElement) {
      perWipeElement.textContent = (perWipeElement.dataset.template ?? '').replace('[price]', perWipe);
      perWipeElement.hidden = perWipe === '';
    }

    const image = this.querySelector('.chooser-card__image');
    const { imageSrc, imageSrcset, imageAlt } = input.dataset;
    if (image instanceof HTMLImageElement && imageSrc) {
      if (imageSrcset) image.srcset = imageSrcset;
      image.src = imageSrc;
      image.alt = imageAlt ?? image.alt;
    }

    const details = this.querySelector('[data-chooser-details]');
    if (details instanceof HTMLAnchorElement && url) details.href = url;

    const button = this.querySelector('form button[type="submit"], form button[name="add"]');
    if (button instanceof HTMLButtonElement) button.disabled = available !== 'true';
  };
}

if (!customElements.get('chooser-card')) {
  customElements.define('chooser-card', ChooserCard);
}
